import { useMemo } from 'react';

import { GenericFailure } from '@playq/services-shared';
import { AppInventoryPackageResponse } from '@playq/octopus2-economy';
import { PackageID } from '@playq/services-bookkeeper';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks/';

import { appsPackagesService } from './constants';

export const appsPackageRetrieveKeys: unknown[] = ['apps', 'package', 'retrieve'];

export const useAppsPackageRetrieve = (
  id: PackageID,
  version?: number,
  options?: IUseQueryOptionsExtended<AppInventoryPackageResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => appsPackageRetrieveKeys.concat(id, version ?? 'latest'), [id, version]);
  const { mutate, ...res } = useEitherQuery(keys, () => appsPackagesService.retrieve(id, version), {
    meta: {
      logOnError: true,
    },
    ...options,
  });

  return {
    ...res,
    mutate,
  };
};
